// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardSummaryState, STATE_NAME } from './dashboard-summary.reducer';

const currentState = createFeatureSelector<DashboardSummaryState>(STATE_NAME);

export const selectIsLoading = createSelector(
  currentState,
  (state: DashboardSummaryState) => state.isLoading,
);

export const selectDashboardSummaryError = createSelector(
  currentState,
  (state: DashboardSummaryState) => state.summaryError,
);

export const selectDashboardSummary = createSelector(
  currentState,
  (state: DashboardSummaryState) => state.summary ? state.summary : undefined,
);

export const selectAreCompetitorsDefined = createSelector(
  currentState,
  (state: DashboardSummaryState) => state.summary && state.summary.competitorStores && state.summary.competitorStores.numberOfStores > 0,
);
